export default __webpack_public_path__ + "static/media/undraw_add_user_re_5oib.91ef570d.svg";